export enum FormState {
  READY_FOR_SUBMISSION = 'READY_FOR_SUBMISSION',
  LOADING = 'LOADING',
  SUBMITTED = 'SUBMITTED',
  ERROR = 'ERROR',
}
